/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { GridCellBase } from "./GridCellBase";
import { Base, runOn, markType } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
/**
 * @hidden
 */
var ImageCell = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ImageCell, _super);
    function ImageCell(a) {
        var _this = _super.call(this, a) || this;
        _this.cn = null;
        _this.ch = 1;
        _this.ci = 3;
        _this.cp = null;
        _this.cj = false;
        _this.ck = 1;
        _this.cm = null;
        _this.cn = a.createElement("img");
        _this.cn.listen("load", runOn(_this, _this.cs));
        _this.cm = a.createElement("div");
        _this.cm.setRawStyleProperty("background-size", "contain");
        _this.cm.setRawStyleProperty("background-repeat", "no-repeat");
        _this.cm.setRawStyleProperty("background-position", "center");
        _this.cm.setRawStyleProperty("width", "100%");
        _this.cm.setRawStyleProperty("height", "100%");
        _this.ae.setRawStyleProperty("text-align", "left");
        _this.ae.setRawStyleProperty("vertical-align", "middle");
        _this.ae.append(_this.cm);
        return _this;
    }
    Object.defineProperty(ImageCell.prototype, "co", {
        get: function () {
            return this.cn;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageCell.prototype, "cl", {
        get: function () {
            return this.ck;
        },
        set: function (a) {
            this.ck = a;
        },
        enumerable: false,
        configurable: true
    });
    ImageCell.prototype.cs = function (a) {
        this.cj = false;
        if (!stringIsNullOrEmpty(this.cp)) {
            this.cm.setRawStyleProperty("opacity", "1");
            this.cm.setRawStyleProperty("background-image", "url(" + this.cp + ")");
        }
    };
    ImageCell.prototype.ct = function (a, b) {
        if (a == this.cp) {
            return;
        }
        this.cq();
        this.cm.setRawStyleProperty("opacity", "0");
        if (a == null || a.length == 0) {
            this.cr(this.cn);
            return;
        }
        if (Base.equalsStatic(a, this.cp)) {
            return;
        }
        this.cx(a, b);
        var img_ = this.cn.getNativeElement();
        if (img_ != null && (img_.complete)) {
            this.cj = false;
            this.cn.setRawStyleProperty("opacity", "1");
            this.cm.setRawStyleProperty("background-image", "url(" + this.cp + ")");
        }
    };
    ImageCell.prototype.cr = function (a) {
        a.setAttribute("src", "");
        this.cm.setRawStyleProperty("background-image", "");
    };
    ImageCell.prototype.cw = function (a) {
        switch (a) {
            case 1:
                this.cm.setRawStyleProperty("background-size", "100% 100%");
                break;
            case 2:
                this.cm.setRawStyleProperty("background-size", "auto");
                break;
            case 0:
                this.cm.setRawStyleProperty("background-size", "contain");
                break;
        }
    };
    ImageCell.prototype.cx = function (a, b) {
        this.cj = true;
        this.cp = a;
        this.co.setAttribute("src", a);
    };
    ImageCell.prototype.cq = function () {
        if (this.cj) {
            this.cr(this.cn);
            this.cp = "";
        }
    };
    ImageCell.prototype.cu = function (a) {
        this.ch = a;
    };
    ImageCell.prototype.cv = function (a) {
        this.ci = a;
    };
    ImageCell.prototype.get_w = function () {
        return true;
    };
    ImageCell.prototype.bp = function (a, b, c) {
        _super.prototype.bp.call(this, a, b, c);
        if (a == "Indent" || a == "IsCollapsable") {
            this.cm.setRawStyleProperty("margin-left", this.a0 + this.a2 + this.a1 + "px");
        }
    };
    ImageCell.$t = markType(ImageCell, 'ImageCell', GridCellBase.$);
    return ImageCell;
}(GridCellBase));
export { ImageCell };
//# sourceMappingURL=ImageCell.js.map
